<template>
  <li class="cart-product">

    <!-- Header -->
    <header class="cart-product__header">
      <output
        v-if="!editable" 
        class="cart-product__qty">{{ item.quantity }}x</output>

      <!-- Name -->
      <div class="cart-product__title">{{ item.product.name }}</div>
      
      <!-- QTY -->
      <forms-qty 
        class="cart-product__qty"
        size="s"
        v-if="editable"
        v-model.number="item.quantity"
        :min="0"
        @change="onChangeQuantity(item)"
        />
      
      <!-- Price -->
      <div class="cart-product__price">
        <span>{{ itemPrice(item) }}</span>
      </div>
    </header>

    <!-- Body -->
    <div 
      v-if="hasOptions" 
      class="cart-product__body">
      <ul class="cart-product__options">
        <li 
          class="cart-product__option" 
          :key="option"
          v-for="option in options"
        >{{ option }}</li>
      </ul>
    </div>
  </li>
</template>


<script>
import { mapActions } from 'vuex'
import { CartItem } from '@sayl/oat-core'
import FormsQty from '@/components/forms/qty'
import PriceMixin from '@/modules/catalog/mixins/price'

export default {
  name: 'CartItem',

  components: {
    FormsQty
  },

  mixins: [
    PriceMixin
  ],

  props: {
    editable: {
      type: Boolean,
      default: false
    },
    
    item: {
      type: CartItem,
      required: true
    }
  },

  computed: {
    hasOptions(){
      return this.item.selectedOptions && this.item.selectedOptions.length > 0
    },

    options(){
      let o = this.item.selectedOptions || [];
      return o.filter( option => option != null )
    }
  },

  methods: {
    ...mapActions({
      removeFromCart: 'removeFromCart',
      updateCart: 'updateCart'
    }),

    itemPrice(item){
      return this.toCurrency({ value: item.total.price.value })
    },

    hasPromoPrice(item){
      return !!item.total.promo
    },

    itemPromoPrice(item){
      return this.toCurrency({ value: item.total.promo.value })
    },

    onChangeQuantity(item) {
      this.updateCart(item);
    }
  }
}
</script>
